import { ComponentPublicInstance, defineComponent, reactive, ref } from 'vue'
import { Button } from '../components/button'
import { useStore } from './state'
import { useRouter } from 'vue-router'
import AgreeDetail from './3. 동의(상세)'
import Section from '../components/section'
import { Spinner } from '../components/spinner'

export default defineComponent({
  setup () {
    const router = useRouter()
    const store = useStore()
    store.initStage(3)

    const state = reactive({
      loading: false,
    })

    const detailRef = ref<ComponentPublicInstance>()

    const goToNext = async () => {
      if (store.email === '') return alert('이메일을 입력해주세요')
      if (store.phone === '') return alert('전화번호를 입력해주세요')
      if (store.agree !== true) {
        if (detailRef.value) {
          ;(detailRef.value as any).scroll?.()
        }
        return alert('동의서 하단에 동의를 체크해주세요')
      }
      if (store.name === '') {
        if (detailRef.value) {
          ;(detailRef.value as any).scroll?.()
        }
        return alert('동의서 하단에 이름을 입력해주세요')
      }

      if (store.stageValidity === true) {
        state.loading = true
        await store.makeUUID()
        router.push({
          name: 'stage4',
        })
      } else {
        // state.showInvalidPopup = true
      }
    }

    return () => (
      <div class="py-20 mx-auto">
        <Section onlyMobile={false}>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            설문참여를 위해 정보를 입력해주세요
          </div>
        </Section>
        <Section>
          <div class="border rounded p-4 max-h-[80vh] overflow-auto">
            <AgreeDetail ref={detailRef} />
          </div>
        </Section>
        {/* <div>
          <input
            type="checkbox"
            id="checkbox"
            value={store.agree}
            onInput={(e) => {
              store.agree = (e.target as HTMLInputElement).checked
            }}
          />
          <label for="checkbox" class="ml-2">
            연구내용에 동의합니다
          </label>
        </div> */}
        <Section class="items-center">
          <div class="font-bold text-lg basis-20">이메일</div>
          <div class="ml-4 grow">
            <input
              class="border rounded p-4 w-full"
              placeholder="example@gmail.com"
              type="email"
              value={store.email}
              onInput={(e) => {
                store.email = (e.target as HTMLInputElement).value.trim()
              }}
            />
          </div>
        </Section>
        <Section class="items-center">
          <div class="font-bold text-lg basis-20">전화번호</div>
          <div class="ml-4 grow">
            <input
              class="border rounded p-4 w-full"
              placeholder="010-1234-1234"
              type="tel"
              value={store.phone}
              onInput={(e) => {
                store.phone = (e.target as HTMLInputElement).value.trim()
              }}
            />
          </div>
        </Section>
        <Section>
          <Button class="w-full" onClick={goToNext} disabled={state.loading}>
            <div class="flex justify-center items-center">
              <div class="mr-2">
                <Spinner v-show={state.loading} />
              </div>
              <div>지원하기</div>
            </div>
          </Button>
        </Section>
        {/* <Teleport to="body">
          <Dialog
            visible={compState.showPopup}
            onClose={() => {
              router.replace('/')
            }}
            closeOnBackdrop
          >
            <div class="px-5 py-12 max-w-xs mx-auto">
              <div v-show={compState.sending}>전송중...</div>
              <div v-show={!compState.sending && compState.isSuccess}>
                입력해주신 이메일로 영업일 1~2 일 이내에 참여방법에 대해
                안내드리겠습니다.
                <br />
                감사합니다.
                <br />
              </div>
            </div>
            <div v-show={!compState.sending && !compState.isSuccess}>
              에러발생!
            </div>
          </Dialog>
        </Teleport> */}
      </div>
    )
  },
})
